import React, { Component } from 'react'
import {Row, Col, Label, Input} from "reactstrap";
import {observer} from "mobx-react";
import ModalForm from "../../../comum/components/ModalForm";
import CabotagemImportarXLSStore from "../stores/CabotagemImportarXLSStore";
import FormSelectSimples from "../../../comum/components/FormSelectSimples";
import {IconeCarregar} from "../../../comum/components/Icones";
import modelo from '../../../../assets/downloads/modelo_planilha_cte.xlsx'

@observer
export class CabotagemImportaXLS extends Component {
    constructor(props) {
        super(props);

        this.controller = new CabotagemImportarXLSStore(this.props.service);
        this.controllerCabotagem = this.props.controller;

        this.state = {
            salvado: false
        }
    };

    mensagemErroXML = () => {
        if (this.controller.erroImportXML)
            return <div className='label-obrigatorio alerta-arquivo pt-2 pb-1'>
                <Label>Falha ao carregar arquivo. Verifique o seu conteúdo e tente novamente.</Label>
            </div>;
        else
            if (this.controller.xmlVazio)
                return <div className='label-obrigatorio alerta-arquivo pt-2'>
                    <Label>Nenhum item localizado.</Label>
                </div>;
    };

    validar = () => {
        return this.controller.navioSelecionado;
    };

    handleAdicionarXML = () => {
        this.setState({salvado: true});
        if (this.validar()) {
            this.controllerCabotagem.incluirListaCabotagem(this.controller.listaNovas, this.controller.navioSelecionado.value);
        }
    };

    render() {
        const naoSalvar = this.controller.listaArquivos.length===0;
        return (
            <ModalForm salvando={this.controllerCabotagem.validandoXML} className="area-form-modal"
                    onClickCancelar={ () => this.controllerCabotagem.inserindoXml = false }
                    labelConfirmar='CARREGAR'
                    onClickSalvar={ this.handleAdicionarXML }
                    esconderSalvar={ naoSalvar } >
                <h2>Importar planilha</h2>
                <Row className="pb-0">
                    <FormSelectSimples titulo="Navio *" xs={12} sm={12} md={12} lg={12} xl={12}
                                       itens={ this.controllerCabotagem.naviosFiltros }
                                       dado={ this.controller.navioSelecionado }
                                       alerta={ !this.controller.navioSelecionado && this.state.salvado ? "Campo obrigatório" : false }
                                       onChange={ (event) => this.controller.setNavio(event) } />
                    <Col sm={12} md={12}>
                        <Label>Anexar arquivo</Label>
                        <Input type="file" onChange={e => this.controller.guardaXML(e)} accept=".xls, .xlsx" />
                        {<Label className="mb-0"><a href={modelo} download="modelo_planilha_cte.xlsx">Baixar modelo de planilha</a></Label>}
                        { this.mensagemErroXML()}
                    </Col>
                </Row>
                { this.controller.listaArquivos
                    &&  this.controller.listaArquivos.map((nova, x) => ( <Row key={x}><Col><Label>{ nova.nomeArquivo }</Label></Col></Row> ))
                }
                { this.controller.salvando
                    && <IconeCarregar tamanho="2x" cor="#001C43" />
                }
            </ModalForm>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/cabotagem/components/CabotagemImportaXLS.js